module.exports = __webpack_public_path__ + "img/eqHeader4.6b947a93.png";